import { render, staticRenderFns } from "./prompt-message.vue?vue&type=template&id=511d9407&scoped=true&"
import script from "./prompt-message.vue?vue&type=script&lang=js&"
export * from "./prompt-message.vue?vue&type=script&lang=js&"
import style0 from "./prompt-message.vue?vue&type=style&index=0&id=511d9407&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511d9407",
  null
  
)

export default component.exports